@let isClickable = (isOnAttendantConsole$ | async) ?? false;
@let pinnedServices = pinnedServices$ | async;

@if (pinnedServices?.length) {
  <div class="header-bar-pinned-services">
    @for (service of pinnedServices; track service.teamId) {
      <div class="header-bar-pinned-service" [class.clickable]="isClickable">
        <button
          type="button"
          class="header-bar-pinned-service-unpin"
          [attr.aria-label]="TranslationKeys.HeaderBarUnpinService | translate"
          (click)="unpin(service, $event)"
        >
          <i class="header-bar-pinned-service-pin" [nimbusIcon]="ICONS.STAR"></i>
          <nimbus-tooltip
            [text]="TranslationKeys.HeaderBarUnpinService | translate"
            [ariaLabel]="TranslationKeys.HeaderBarUnpinService | translate"
          ></nimbus-tooltip>
        </button>
        <button
          type="button"
          class="header-bar-pinned-service-main"
          [attr.tabindex]="isClickable ? 0 : -1"
          [attr.aria-label]="service.name"
          (click)="onPinnedClick(service, isClickable)"
        >
          <span class="header-bar-pinned-service-name">
            {{ service.name }}
            <nimbus-tooltip [text]="service.name" [ariaLabel]="service.name"></nimbus-tooltip>
          </span>
          @let queue = (service.queue$ | async) ?? 0;
          <span class="header-bar-pinned-service-queue" [class.has-queue]="queue > 0">
            <i class="header-bar-pinned-service-queue-icon" [nimbusIcon]="ICONS.LAYER_GROUP"></i>
            <span>{{ queue }}</span>
          </span>
        </button>
      </div>
    }
  </div>
}
